import * as Sentry from '@sentry/browser'
import {
  SET_PRICE_POINT,
  TOGGLE_AFFORDABILITY_MODAL,
  SET_AFFORDABILITY_METHOD,
  SET_AFFORDABILITY_VALUES,
  DISPLAY_PREQUAL_PROMPT,
  SEND_PREQUAL_REQUEST,
  SEND_PREQUAL_SUCCESS,
  SEND_PREQUAL_FAILURE
} from './actionTypes'
import {
  selectPersistableAffordabilityValues,
  selectPromptPrequalFromAffordability,
  selectBuyerMethod
} from 'src/store/selectors/affordability'
import { selectBuyerId } from 'src/store/selectors/buyerInfo'
import { createBuyerMessage } from 'src/api/mikasa/requests'
import { updateBuyerInfo } from './buyerInfo'
import { SYSTEM_REQUEST } from 'src/constants/messages'
import { BUYER_PREQUAL_REQUEST_TOPIC_KEY } from 'src/constants/topicKeys'
import { QUESTION_REQUESTED_PREQUAL } from 'src/constants/affordability'
import { saveClientAnswer } from 'src/actions/client'

export const setAffordabilityMethod = affordabilityMethod => ({
  type: SET_AFFORDABILITY_METHOD,
  affordabilityMethod
})

export const setDefaultAffordabilityMethod = () => async (
  dispatch,
  getState
) => {
  const state = getState()
  const defaultMethod = selectBuyerMethod(state)

  dispatch(setAffordabilityMethod(defaultMethod))
}

export const setPricePoint = pricePoint => ({
  type: SET_PRICE_POINT,
  pricePoint
})

export const toggleAffordabilityModal = () => ({
  type: TOGGLE_AFFORDABILITY_MODAL
})

export const setAffordabilityValues = affordability => ({
  type: SET_AFFORDABILITY_VALUES,
  ...affordability
})

export const displayPrequalPrompt = () => ({
  type: DISPLAY_PREQUAL_PROMPT
})

export const persistAffordability = () => (dispatch, getState) => {
  const state = getState()

  const values = selectPersistableAffordabilityValues(state)
  const showPrompt = selectPromptPrequalFromAffordability(state)

  if (showPrompt) {
    dispatch(displayPrequalPrompt())
  } else {
    dispatch(toggleAffordabilityModal())
  }

  dispatch(updateBuyerInfo(values))
}

export const sendPrequalRequestForClient = () => async (dispatch, getState) => {
  const state = getState()
  const buyerId = selectBuyerId(state)

  dispatch({ type: SEND_PREQUAL_REQUEST })

  try {
    await createBuyerMessage(buyerId, {
      topic: SYSTEM_REQUEST.prequalTopic.defaultMessage,
      topicKey: BUYER_PREQUAL_REQUEST_TOPIC_KEY,
      message: SYSTEM_REQUEST.prequalMessage.defaultMessage
    })

    dispatch({ type: SEND_PREQUAL_SUCCESS })
    dispatch(
      saveClientAnswer({
        question: QUESTION_REQUESTED_PREQUAL,
        response: {
          value: true
        }
      })
    )
  } catch (error) {
    Sentry.captureException(error)
    dispatch({
      type: SEND_PREQUAL_FAILURE,
      error
    })
  }
}
